/** N'accepte que des destinations internes, jamais une URL fournie par un tiers. */
export function destinationConnexion(cible: string, defaut = "/"): string {
  if (!cible.startsWith("/") || cible.startsWith("//") || /[\\\s]/.test(cible)) return defaut;
  const url = new URL(cible, "https://hopitech.invalid");
  if (["/", "/login", "/public"].includes(url.pathname)) return defaut;
  return url.pathname + url.search + url.hash;
}
